import { Card } from "antd";

const SummaryCard = ({
  label,
  value,
  icon,
  active,
  onClick,
  colorClass
}) => {
  return (
    <Card
      hoverable
      onClick={onClick}
      className={`summary-card ${colorClass} ${active ? "active" : ""}`}
    >
      <div className="summary-card-content">
        <div>
          <div className="summary-label">{label}</div>
          <div className="summary-value">{value}</div>
        </div>

        <div className="summary-icon">
          {icon}
        </div>
      </div>
    </Card>
  );
};

export default SummaryCard;
